import React from 'react';

const SettingsTab = ({
  settingsForm,
  setSettingsForm,
  saveSettings,
  isDarkMode
}) => {
  return (
    <div className={`rounded-xl p-5 ${isDarkMode ? 'bg-gray-800' : 'bg-white'} shadow space-y-5`}>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className={`block text-sm mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>Bot Name</label>
          <input type="text" value={settingsForm.botName} onChange={(e) => setSettingsForm(prev => ({ ...prev, botName: e.target.value }))}
            className={`w-full px-3 py-2 rounded-lg border text-sm ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`} />
        </div>
        <div>
          <label className={`block text-sm mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>Avatar Emoji</label>
          <input type="text" value={settingsForm.avatar} onChange={(e) => setSettingsForm(prev => ({ ...prev, avatar: e.target.value }))}
            className={`w-full px-3 py-2 rounded-lg border text-sm ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`} />
        </div>
      </div>
      
      <div>
        <label className={`block text-sm mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>Custom Avatar URL</label>
        <input type="text" value={settingsForm.avatarUrl || ''} onChange={(e) => setSettingsForm(prev => ({ ...prev, avatarUrl: e.target.value }))}
          className={`w-full px-3 py-2 rounded-lg border text-sm ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`} placeholder="https://..." />
        {settingsForm.avatarUrl && <img src={settingsForm.avatarUrl} alt="Preview" className="mt-2 w-12 h-12 rounded-full object-cover" />}
      </div>

      <div className="space-y-4">
        <h3 className={`text-sm font-semibold uppercase tracking-wide ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>Visibility & Access</h3>

        {/* Show / Hide Toggle */}
        <div className={`flex items-center justify-between p-4 rounded-lg border ${isDarkMode ? 'border-gray-700 bg-gray-750' : 'border-gray-200 bg-gray-50'}`}>
          <div>
            <div className={`text-sm font-medium ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>Show / Hide Bot</div>
            <div className={`text-xs mt-0.5 ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
              {settingsForm.enabled ? 'Bot is visible on the website' : 'Bot is hidden from the entire website'}
            </div>
          </div>
          <button
            onClick={() => setSettingsForm(prev => ({ ...prev, enabled: !prev.enabled }))}
            className={`relative w-12 h-6 rounded-full transition-colors ${settingsForm.enabled ? 'bg-green-500' : 'bg-gray-400'}`}
          >
            <span className={`absolute top-0.5 w-5 h-5 bg-white rounded-full shadow transition-transform ${settingsForm.enabled ? 'left-6' : 'left-0.5'}`} />
          </button>
        </div>
        <div className={`text-xs px-2 ${settingsForm.enabled ? 'text-green-500' : 'text-red-400'}`}>
          Status: {settingsForm.enabled ? 'Showing' : 'Hidden'}
        </div>

        {/* Paid / Free Toggle */}
        <div className={`flex items-center justify-between p-4 rounded-lg border ${isDarkMode ? 'border-gray-700 bg-gray-750' : 'border-gray-200 bg-gray-50'}`}>
          <div>
            <div className={`text-sm font-medium ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>Paid / Free Access</div>
            <div className={`text-xs mt-0.5 ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
              {settingsForm.freeUserEnabled ? 'Everyone can use the bot (free & paid)' : 'Only paid members can use the bot'}
            </div>
          </div>
          <button
            onClick={() => setSettingsForm(prev => ({ ...prev, freeUserEnabled: !prev.freeUserEnabled }))}
            className={`relative w-12 h-6 rounded-full transition-colors ${settingsForm.freeUserEnabled ? 'bg-green-500' : 'bg-yellow-500'}`}
          >
            <span className={`absolute top-0.5 w-5 h-5 bg-white rounded-full shadow transition-transform ${settingsForm.freeUserEnabled ? 'left-6' : 'left-0.5'}`} />
          </button>
        </div>
        <div className={`text-xs px-2 ${settingsForm.freeUserEnabled ? 'text-green-500' : 'text-yellow-500'}`}>
          Access: {settingsForm.freeUserEnabled ? 'Free for everyone' : 'Paid members only'}
        </div>
      </div>

      <div>
        <label className={`block text-sm mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>Initial Delay (seconds)</label>
        <input type="number" value={settingsForm.initialDelaySeconds} onChange={(e) => setSettingsForm(prev => ({ ...prev, initialDelaySeconds: parseInt(e.target.value) }))}
          className={`w-24 px-3 py-2 rounded-lg border text-sm ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`} />
      </div>

      <div>
        <label className={`block text-sm font-semibold mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>Travel Price Disclaimer</label>
        <p className={`text-xs mb-2 ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>
          Shown under transport prices in Travel Help. Prices are entered manually, so remind users to verify.
        </p>
        <textarea
          value={settingsForm.transportDisclaimer || ''}
          onChange={(e) => setSettingsForm(prev => ({ ...prev, transportDisclaimer: e.target.value }))}
          rows={2}
          className={`w-full px-3 py-2 rounded-lg border text-sm ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-500' : 'bg-white border-gray-300'}`}
          placeholder="e.g. Prices are approximate — verify with station."
        />
      </div>

      <button onClick={saveSettings} className="px-5 py-2 bg-purple-600 text-white text-sm font-medium rounded-lg">
        Save Settings
      </button>
    </div>
  );
};

export default SettingsTab;
